import { Box, Divider, FormControl, Typography, Grid2, InputLabel, MenuItem, Paper, Select, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Card, CardContent, CardHeader, Button, CircularProgress, useTheme } from "@mui/material";
import PersonIcon from '@mui/icons-material/Person';
import PreviewIcon from '@mui/icons-material/Preview';
import { useNavigate } from "react-router-dom";
import { StyledTableCell, StyledTableRow } from "../../theme";
import React, { useEffect, useState, useRef } from "react";
import { useAuth, isStudent, isTrial } from "../../contexts/AuthContext";
import { BronzeMedal, GoldMedal, SilverMedal } from "../../constants/Constants";
import { InvokeAPI } from "../../apis/API";
import AsyncSection from "../../components/common/AsyncSection";
import { useAsyncAction } from "../../components/common/useAsyncAction";
import { getUserMgmtBase, getAssessmentMgmtBase, getAiMgmtBase } from "../../config/apiBase";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";

//Get enrolled users list
//If nothing then only self in users list and user needs to be active
//Else dont show anything

//Get the leaderboard

const Overview = () => {
    const { user, logout } = useAuth();
    const isThisStudent = isStudent()
    const isThisTrial = isTrial()
    const navigate = useNavigate();
    const [users, setUsers] = useState([{
        ID: user.id,
        Username: user.username,
        IsActive: user.isActive,
    }])

    //UseEffect to get the enrolled users list
    const getUserData = async () => {
        const uinfo = await InvokeAPI(`${getUserMgmtBase()}/v1/user/enrolled`,
            { "EnrollerID": user["id"] },
            'POST',
            { "authorization": user["token"] },
            false)
        if (uinfo["unauthenticated"] == true || uinfo["unauthorized"] == true) {
            logout(user);
        }
        //console.log(uinfo.response)
        return (uinfo.response["EnrolledUsers"] || []).filter((enrolledUser) => enrolledUser.IsActive === true)
    }

    useEffect(() => {
        //Some function
        getUserData().then(enrolledUsers => setUsers({ ...users, enrolledUsers }))
    }, [])

    const Leaderboard = () => {
        const [boardDetails, setBoardDetails] = useState()
        const getUserData = async () => {
            const uinfo = await InvokeAPI(`${getUserMgmtBase()}/v1/user/leaderboard`,
                {},
                'POST',
                { "authorization": user["token"] },
                false)
            if (uinfo["unauthenticated"] == true || uinfo["unauthorized"] == true) {
                logout(user);
            }
            //console.log(uinfo.response)
            return uinfo.response["UsersLeaderboard"]
        }

        useEffect(() => {
            //Some function
            getUserData().then(data => setBoardDetails(data))
        }, [])




        return (
            <Box>
                <Box display="flex" justifyContent="center" alignItems="center">
                    <h2>Leaderboard</h2>
                </Box>
                <TableContainer component={Paper}>
                    <Table aria-label="customized table">
                        <TableHead>
                            <TableRow>
                                <StyledTableCell>Username</StyledTableCell>
                                <StyledTableCell>Rank</StyledTableCell>
                                <StyledTableCell>Assigned Count</StyledTableCell>
                                <StyledTableCell>Attempted Count</StyledTableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {boardDetails && boardDetails.map((row) => (
                                <StyledTableRow key={row.UserName}>
                                    <StyledTableCell component="th" scope="row">
                                        {row.UserName}
                                    </StyledTableCell>
                                    <StyledTableCell >{row.Rank}</StyledTableCell>
                                    <StyledTableCell >{row.AssignedAssessment}</StyledTableCell>
                                    <StyledTableCell >{row.AttemptedAssessment}</StyledTableCell>
                                </StyledTableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </Box>
        )
    }
    const PerUser = () => {
        // per user show stats
        const [statsID, setStatsID] = useState("")
        const [userStats, setUserStats] = useState()
        const [userResponseStats, setUserResponseStats] = useState()
        const [userQLevelStats, setUserQLevelStats] = useState()
        const [assessmentSummaryStats, setAssessmentSummaryStats] = useState({ Stats: [] })
        const [medalStats, setMedalStats] = useState({ Gold: 0, Silver: 0, Bronze: 0 })

        // new subject-wise stats (via userMgmt)
        const [attemptedSubjects, setAttemptedSubjects] = useState([])
        const [selectedSubject, setSelectedSubject] = useState("")
        const [availableCategories, setAvailableCategories] = useState([])
        const [selectedCategory, setSelectedCategory] = useState("__overall")
        const [subjectCategoryStats, setSubjectCategoryStats] = useState([])           // counts correct/incorrect
        const [subjectCategoryTimeStats, setSubjectCategoryTimeStats] = useState([])   // time stats
        const [subjectCategoryLevelStats, setSubjectCategoryLevelStats] = useState([]) // level counts
        const [aiAnalysis, setAIAnalysis] = useState("")
        const [aiAnalysisLoading, setAIAnalysisLoading] = useState(false)
        const [aiAnalysisError, setAIAnalysisError] = useState("")
        const selectorRef = useRef(null);
        const medalsRef = useRef(null);
        const attemptsRef = useRef(null);
        const practiceSummaryRef = useRef(null);
        const trendAnalysisRef = useRef(null);
        const aiInsightRef = useRef(null);
        const accuracyRef = useRef(null);
        const speedRef = useRef(null);
        const levelTrendsRef = useRef(null);
        const [tourOpen, setTourOpen] = useState(false);
        const [tourSection, setTourSection] = useState(0);
        const { run: runOverviewDataLoad, loading: overviewDataLoading } = useAsyncAction();
        const getUserData = async (id) => {
            const uinfo = await InvokeAPI(`${getUserMgmtBase()}/v1/user/stats`,
                { "UserID": id },
                'POST',
                { "authorization": user["token"] },
                false)
            if (uinfo["unauthenticated"] == true || uinfo["unauthorized"] == true) {
                logout(user);
            }
            //console.log(uinfo.response)
            return uinfo.response
        }

        const getUserResponseData = async (id) => {
            const uinfo = await InvokeAPI(`${getAssessmentMgmtBase()}/v1/assessment/response/stats`,
                { "UserID": id },
                'POST',
                { "authorization": user["token"] },
                false)
            if (uinfo["unauthenticated"] == true || uinfo["unauthorized"] == true) {
                logout(user);
            }
            return uinfo.response
        }

        const getUserQLevelData = async (id) => {
            const uinfo = await InvokeAPI(`${getAssessmentMgmtBase()}/v1/assessment/qlevel/stats`,
                { "UserID": id },
                'POST',
                { "authorization": user["token"] },
                false)
            if (uinfo["unauthenticated"] == true || uinfo["unauthorized"] == true) {
                logout(user);
            }
            return uinfo.response
        }

        // new userMgmt stats APIs
        const getAttemptedSubjects = async (id) => {
            const uinfo = await InvokeAPI(`${getUserMgmtBase()}/v1/user/subjects/attempted`,
                { "UserID": id },
                'POST',
                { "authorization": user["token"] },
                false)
            if (uinfo["unauthenticated"] === true || uinfo["unauthorized"] === true) {
                logout(user);
            }
            return uinfo.response?.Subjects || []
        }

        const getSubjectCategoryStats = async (id, subject) => {
            const uinfo = await InvokeAPI(`${getUserMgmtBase()}/v1/user/stats/subject-category`,
                { "UserID": id, "Subject": subject },
                'POST',
                { "authorization": user["token"] },
                false)
            if (uinfo["unauthenticated"] === true || uinfo["unauthorized"] === true) {
                logout(user);
            }
            return uinfo.response?.Stats || []
        }

        const getSubjectCategoryTimeStats = async (id, subject) => {
            const uinfo = await InvokeAPI(`${getUserMgmtBase()}/v1/user/stats/subject-category-time`,
                { "UserID": id, "Subject": subject },
                'POST',
                { "authorization": user["token"] },
                false)
            if (uinfo["unauthenticated"] === true || uinfo["unauthorized"] === true) {
                logout(user);
            }
            return uinfo.response?.Stats || []
        }

        const getSubjectCategoryLevelStats = async (id, subject) => {
            const uinfo = await InvokeAPI(`${getUserMgmtBase()}/v1/user/stats/subject-category-level`,
                { "UserID": id, "Subject": subject },
                'POST',
                { "authorization": user["token"] },
                false)
            if (uinfo["unauthenticated"] === true || uinfo["unauthorized"] === true) {
                logout(user);
            }
            return uinfo.response?.Stats || []
        }

        const getAssessmentSummaryStats = async (id) => {
            const uinfo = await InvokeAPI(`${getUserMgmtBase()}/v1/user/stats/summary`,
                { "UserID": id },
                'POST',
                { "authorization": user["token"] },
                false)
            if (uinfo["unauthenticated"] === true || uinfo["unauthorized"] === true) {
                logout(user);
            }
            return uinfo.response || null
        }

        const getMedalStats = async (id) => {
            const uinfo = await InvokeAPI(`${getUserMgmtBase()}/v1/user/stats/medals`,
                { "UserID": id },
                'POST',
                { "authorization": user["token"] },
                false)
            if (uinfo["unauthenticated"] === true || uinfo["unauthorized"] === true) {
                logout(user);
            }
            return uinfo.response || { Gold: 0, Silver: 0, Bronze: 0 }
        }

        const getAIAnalysis = async (id, subject, category) => {
            const uinfo = await InvokeAPI(`${getAiMgmtBase()}/v1/ai/analysis/get`,
                {
                    "UserID": id,
                    "Subject": subject,
                    "Category": category || "__overall",
                },
                'POST',
                { "authorization": user["token"] },
                false)
            if (uinfo["unauthenticated"] === true || uinfo["unauthorized"] === true) {
                logout(user);
            }
            if (uinfo["iserror"] === true) {
                throw new Error(uinfo["errorMessage"] || "Unable to fetch AI analysis")
            }
            return uinfo.response?.Analysis || ""
        }

        // helper to refresh available categories based on stats
        const updateCategoriesFromStats = (stats) => {
            const cats = Array.from(new Set((stats || []).map(s => s.Category))).sort();
            setAvailableCategories(cats);
            if (cats.length === 0) {
                setSelectedCategory("__overall");
                return;
            }
            // Prefer "__overall" if present
            if (cats.includes("__overall")) {
                setSelectedCategory("__overall");
            } else if (!cats.includes(selectedCategory)) {
                setSelectedCategory(cats[0]);
            }
        }

        const tourSections = [
            ...(!isStudent() ? [{
                title: "Student Selector",
                description: "Choose a student to view their performance insights across this dashboard.",
                targetRef: selectorRef,
            }] : []),
            {
                title: "Medals",
                description: "Quick summary of gold, silver, and bronze counts for the selected student.",
                targetRef: medalsRef,
            },
            {
                title: "Latest 5 Attempts",
                description: "Shows recent assessments, scores, and a quick Review action.",
                targetRef: attemptsRef,
            },
            {
                title: "Practice Summary",
                description: "Subject-wise attempted, pending, average score, and max score overview.",
                targetRef: practiceSummaryRef,
            },
            {
                title: "Trend analysis",
                description: "Use Filters to choose a subject and, corresponding category for that subject. The accuracy, speed, and level trend charts below all update together so you can explore performance for that subject and category.",
                targetRef: trendAnalysisRef,
            },
            ...(!isStudent() ? [{
                title: "AI Insight",
                description: "After you pick a subject (and category when available), this card shows an AI-generated summary of how you are doing, what to focus on, and practical next steps. It refreshes when you change the filters above.",
                targetRef: aiInsightRef,
            }] : []),
            {
                title: "Accuracy (Counts)",
                description: "Correct vs incorrect counts over time for your selected subject and category.",
                targetRef: accuracyRef,
            },
            {
                title: "Speed (Time)",
                description: "Average time for correct vs incorrect responses over time for your selected subject and category.",
                targetRef: speedRef,
            },
            {
                title: "Level Trends (Counts)",
                description: "Easy, intermediate, and advanced question counts over time for your selected subject and category.",
                targetRef: levelTrendsRef,
            },
        ];

        const startTour = () => {
            setTourSection(0);
            setTourOpen(true);
        };

        const closeTour = () => {
            setTourOpen(false);
        };

        const goToTourSection = (nextSection) => {
            if (nextSection < 0) return;
            if (nextSection >= tourSections.length) {
                closeTour();
                return;
            }
            setTourSection(nextSection);
        };

        useEffect(() => {
            if (!tourOpen) return;
            const target = tourSections[tourSection]?.targetRef?.current;
            if (!target) return;
            let cancelled = false;
            // Defer until layout/paint so refs and heights are stable (nested cards, charts).
            const outer = requestAnimationFrame(() => {
                requestAnimationFrame(() => {
                    if (!cancelled) {
                        target.scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest" });
                    }
                });
            });
            return () => {
                cancelled = true;
                cancelAnimationFrame(outer);
            };
        }, [tourOpen, tourSection]);

        useEffect(() => {
            //Some function
            if (isThisStudent) {
                getUserData(users[0].ID).then(data => {
                    setUserStats(data);
                    setStatsID(users[0].ID)
                })
                getUserResponseData(users[0].ID).then(data => { setUserResponseStats(data); setStatsID(users[0].ID) })
                getUserQLevelData(users[0].ID).then(data => { setUserQLevelStats(data); setStatsID(users[0].ID) })
                getAssessmentSummaryStats(users[0].ID).then(data => { setAssessmentSummaryStats(data) })
                getMedalStats(users[0].ID).then(data => { setMedalStats(data) })
                // subject-based stats for self
                getAttemptedSubjects(users[0].ID).then(subs => {
                    setAttemptedSubjects(subs);
                    if (subs && subs.length > 0) {
                        const firstSub = subs[0];
                        setSelectedSubject(firstSub);
                        getSubjectCategoryStats(users[0].ID, firstSub).then(s => {
                            setSubjectCategoryStats(s);
                            updateCategoriesFromStats(s);
                        });
                        getSubjectCategoryTimeStats(users[0].ID, firstSub).then(setSubjectCategoryTimeStats);
                        getSubjectCategoryLevelStats(users[0].ID, firstSub).then(setSubjectCategoryLevelStats);
                    } else {
                        setSelectedSubject("");
                        setSubjectCategoryStats([]);
                        setSubjectCategoryTimeStats([]);
                        setSubjectCategoryLevelStats([]);
                    }
                })
            }
            if (statsID === "") {
                if (users && users.enrolledUsers && users.enrolledUsers.length > 0) {
                    getUserData(users.enrolledUsers[0].ID).then(data => {
                        setUserStats(data);
                        setStatsID(users.enrolledUsers[0].ID)
                    })
                    getUserResponseData(users.enrolledUsers[0].ID).then(data => { setUserResponseStats(data); setStatsID(users.enrolledUsers[0].ID) })
                    getUserQLevelData(users.enrolledUsers[0].ID).then(data => { setUserQLevelStats(data); setStatsID(users.enrolledUsers[0].ID) })
                    getAssessmentSummaryStats(users.enrolledUsers[0].ID).then(data => { setAssessmentSummaryStats(data) })
                    getMedalStats(users.enrolledUsers[0].ID).then(data => { setMedalStats(data) })
                    // subject-based stats for first enrolled user
                    getAttemptedSubjects(users.enrolledUsers[0].ID).then(subs => {
                        setAttemptedSubjects(subs);
                        if (subs && subs.length > 0) {
                            const firstSub = subs[0];
                            setSelectedSubject(firstSub);
                            getSubjectCategoryStats(users.enrolledUsers[0].ID, firstSub).then(s => {
                                setSubjectCategoryStats(s);
                                updateCategoriesFromStats(s);
                            });
                            getSubjectCategoryTimeStats(users.enrolledUsers[0].ID, firstSub).then(setSubjectCategoryTimeStats);
                            getSubjectCategoryLevelStats(users.enrolledUsers[0].ID, firstSub).then(setSubjectCategoryLevelStats);
                        } else {
                            setSelectedSubject("");
                            setSubjectCategoryStats([]);
                            setSubjectCategoryTimeStats([]);
                            setSubjectCategoryLevelStats([]);
                        }
                    })
                }
            }
            /*
            if (statsID !== "") {
                getUserData().then(data => {
                    data.Gold = Number(0)
                    data.Silver = Number(0)
                    data.Bronze = Number(0)
                    data.UserStats.forEach(element => {
                        data.Gold = data.Gold + Number(element.Gold)
                        data.Silver = data.Silver + Number(element.Silver)
                        data.Bronze = data.Bronze + Number(element.Bronze)
                    });
                    setUserStats(data);
                })
                getUserResponseData().then(data => { setUserResponseStats(data) })
            }
                */
        }, [statsID])

        useEffect(() => {
            if (isThisStudent || !statsID || !selectedSubject) {
                setAIAnalysis("")
                setAIAnalysisError("")
                setAIAnalysisLoading(false)
                return
            }

            let active = true
            setAIAnalysisLoading(true)
            setAIAnalysisError("")
            getAIAnalysis(statsID, selectedSubject, selectedCategory)
                .then((analysis) => {
                    if (!active) return
                    setAIAnalysis(analysis || "")
                })
                .catch((err) => {
                    if (!active) return
                    setAIAnalysis("")
                    setAIAnalysisError(err?.message || "Unable to fetch AI analysis")
                })
                .finally(() => {
                    if (!active) return
                    setAIAnalysisLoading(false)
                })

            return () => {
                active = false
            }
        }, [statsID, selectedSubject, selectedCategory])

        const handleChange = async (e) => {
            e.preventDefault();
            const newUserId = e.target.value;
            await runOverviewDataLoad(async () => {
                const [ud, ur, uq, as, ms] = await Promise.all([
                    getUserData(newUserId),
                    getUserResponseData(newUserId),
                    getUserQLevelData(newUserId),
                    getAssessmentSummaryStats(newUserId),
                    getMedalStats(newUserId),
                ]);
                setUserStats(ud);
                setUserResponseStats(ur);
                setUserQLevelStats(uq);
                setAssessmentSummaryStats(as);
                setMedalStats(ms);
                setStatsID(newUserId);

                const subs = await getAttemptedSubjects(newUserId);
                setAttemptedSubjects(subs);
                if (subs && subs.length > 0) {
                    const firstSub = subs[0];
                    setSelectedSubject(firstSub);
                    const s = await getSubjectCategoryStats(newUserId, firstSub);
                    setSubjectCategoryStats(s);
                    updateCategoriesFromStats(s);
                    const [t, l] = await Promise.all([
                        getSubjectCategoryTimeStats(newUserId, firstSub),
                        getSubjectCategoryLevelStats(newUserId, firstSub),
                    ]);
                    setSubjectCategoryTimeStats(t);
                    setSubjectCategoryLevelStats(l);
                } else {
                    setSelectedSubject("");
                    setSubjectCategoryStats([]);
                    setSubjectCategoryTimeStats([]);
                    setSubjectCategoryLevelStats([]);
                }
            });
        }

        const handleSubjectChange = async (e) => {
            const subject = e.target.value;
            await runOverviewDataLoad(async () => {
                setSelectedSubject(subject);
                if (!statsID || !subject) {
                    setSubjectCategoryStats([]);
                    setSubjectCategoryTimeStats([]);
                    setSubjectCategoryLevelStats([]);
                    return;
                }
                const s = await getSubjectCategoryStats(statsID, subject);
                setSubjectCategoryStats(s);
                updateCategoriesFromStats(s);
                const [t, l] = await Promise.all([
                    getSubjectCategoryTimeStats(statsID, subject),
                    getSubjectCategoryLevelStats(statsID, subject),
                ]);
                setSubjectCategoryTimeStats(t);
                setSubjectCategoryLevelStats(l);
            });
        }

        // Helper function to format date from timestamp to YYYY-MM-DD
        const formatDateOnly = (dateStr) => {
            if (!dateStr) return "";
            // If it's already just a date (YYYY-MM-DD), return as is
            if (dateStr.match(/^\d{4}-\d{2}-\d{2}$/)) return dateStr;
            // If it's a timestamp, extract just the date part
            const date = new Date(dateStr);
            if (isNaN(date.getTime())) return dateStr;
            return date.toISOString().split('T')[0];
        };

        // Simple inline SVG line chart
        const SimpleLineChart = ({ data, xKey, series, colors, height = 180, seriesLabels, formatYValue, tooltipKey }) => {
            const theme = useTheme();
            const isDarkMode = theme.palette.mode === 'dark';
            const [tooltip, setTooltip] = useState(null);
            const [containerWidth, setContainerWidth] = useState(520);
            const containerRef = useRef(null);
            const svgRef = useRef(null);
            const tooltipRef = useRef(null);
            
            // Brighter colors for dark mode
            const axisLabelColor = isDarkMode ? "#bbb" : "#666";
            const axisSecondaryLabelColor = isDarkMode ? "#ddd" : "#555";
            const axisLineColor = isDarkMode ? "#888" : "#999";

            useEffect(() => {
                const updateWidth = () => {
                    if (containerRef.current) {
                        setContainerWidth(containerRef.current.offsetWidth);
                    }
                };

                updateWidth();
                window.addEventListener('resize', updateWidth);
                return () => window.removeEventListener('resize', updateWidth);
            }, []);

            // Adjust tooltip position after render to account for actual dimensions
            useEffect(() => {
                if (tooltip && tooltipRef.current && containerRef.current) {
                    // Use requestAnimationFrame to ensure DOM is fully rendered
                    requestAnimationFrame(() => {
                        if (tooltipRef.current && containerRef.current) {
                            const tooltipEl = tooltipRef.current;
                            const containerEl = containerRef.current;
                            const tooltipHeight = tooltipEl.offsetHeight;
                            const tooltipWidth = tooltipEl.offsetWidth;
                            const containerRect = containerEl.getBoundingClientRect();
                            
                            // Calculate position relative to container
                            let tooltipX = tooltip.x;
                            let tooltipY = tooltip.y;
                            
                            // If we have clientX/clientY, use them to recalculate relative position
                            // This accounts for any transforms or scroll changes
                            if (tooltip.clientX !== undefined && tooltip.clientY !== undefined) {
                                tooltipX = tooltip.clientX - containerRect.left;
                                tooltipY = tooltip.clientY - containerRect.top;
                            }
                            
                            // Position above the cursor with 8px gap
                            const finalY = tooltipY - tooltipHeight - 8;
                            
                            // Position to the right of cursor with 10px offset
                            const finalX = tooltipX + 10;
                            
                            // Ensure tooltip doesn't go off container boundaries
                            const maxLeft = containerRect.width - tooltipWidth - 10;
                            const minTop = 0;
                            
                            tooltipEl.style.top = `${Math.max(finalY, minTop)}px`;
                            tooltipEl.style.left = `${Math.min(finalX, maxLeft)}px`;
                            
                            // Make tooltip visible after positioning
                            tooltipEl.style.visibility = 'visible';
                        }
                    });
                }
            }, [tooltip]);

            if (!data || data.length === 0) return <Typography variant="body2">No data available</Typography>;
            const width = containerWidth;
            const paddingLeft = 50;
            const paddingRight = 10;
            const paddingTop = 20;
            const paddingBottom = 60;
            const innerWidth = width - paddingLeft - paddingRight;
            const innerHeight = height - paddingTop - paddingBottom;

            // Distribute points with a margin on both sides so the first/last dots
            // do not sit exactly on the vertical axes.
            const count = data.length;
            const stepX = innerWidth / (Math.max(count, 1) + 1);
            let maxY = 0;
            series.forEach(s => {
                data.forEach(d => {
                    const v = Number(d[s]) || 0;
                    if (v > maxY) maxY = v;
                });
            });
            if (maxY === 0) maxY = 1;

            const scaleY = (v) => paddingTop + innerHeight - (v / maxY) * innerHeight;
            const formatValue = formatYValue || ((v) => Math.round(v).toString());

            // Y-axis ticks
            const yTicks = 5;
            const yTickValues = [];
            for (let i = 0; i <= yTicks; i++) {
                yTickValues.push((maxY / yTicks) * i);
            }

            return (
                <Box ref={containerRef} sx={{ position: 'relative', width: '100%' }}>
                    <svg ref={svgRef} width={width} height={height}>
                        {/* Y-axis */}
                        <line x1={paddingLeft} y1={paddingTop} x2={paddingLeft} y2={paddingTop + innerHeight} stroke={isDarkMode ? "#666" : "#ccc"} strokeWidth="1" />
                        {/* X-axis */}
                        <line x1={paddingLeft} y1={paddingTop + innerHeight} x2={paddingLeft + innerWidth} y2={paddingTop + innerHeight} stroke={isDarkMode ? "#666" : "#ccc"} strokeWidth="1" />

                        {/* Y-axis labels */}
                        {yTickValues.map((val, i) => {
                            const y = scaleY(val);
                            return (
                                <g key={i}>
                                    <line x1={paddingLeft - 5} y1={y} x2={paddingLeft} y2={y} stroke={axisLineColor} strokeWidth="1" />
                                    <text x={paddingLeft - 8} y={y + 4} textAnchor="end" fontSize="9" fill={axisLabelColor}>
                                        {formatValue(val)}
                                    </text>
                                </g>
                            );
                        })}

                        {/* X-axis labels */}
                        {data.map((d, i) => {
                            const x = paddingLeft + stepX * (i + 1);
                            const dateLabel = d.date || d[xKey]?.split(' - ')[0] || '';
                            const anameLabel = (d.aname || d[xKey]?.split(' - ')[1] || '').substring(0, 10);
                            return (
                                <g key={i}>
                                    <line x1={x} y1={paddingTop + innerHeight} x2={x} y2={paddingTop + innerHeight + 4} stroke={axisLineColor} />
                                    <text 
                                        x={x} 
                                        y={paddingTop + innerHeight + 14} 
                                        textAnchor="middle" 
                                        fontSize="9" 
                                        fill={axisLabelColor}
                                    >
                                        {dateLabel}
                                    </text>
                                    {anameLabel && (
                                        <text 
                                            x={x} 
                                            y={paddingTop + innerHeight + 26} 
                                            textAnchor="middle" 
                                            fontSize="8" 
                                            fill={axisSecondaryLabelColor}
                                        >
                                            {anameLabel}
                                        </text>
                                    )}
                                </g>
                            );
                        })}

                        {/* Data lines */}
                        {series.map((s, idx) => {
                            const color = colors[idx] || '#1976d2';
                            const points = data.map((d, i) => {
                                const x = paddingLeft + stepX * (i + 1);
                                const y = scaleY(Number(d[s]) || 0);
                                return `${x},${y}`;
                            }).join(' ');
                            return (
                                <g key={s}>
                                    <polyline
                                        fill="none"
                                        stroke={color}
                                        strokeWidth="2"
                                        points={points}
                                    />
                                    {/* Data points */}
                                    {data.map((d, i) => {
                                        const baseX = paddingLeft + stepX * (i + 1);
                                        const y = scaleY(Number(d[s]) || 0);

                                        // Check if values overlap with other series at this point
                                        let offsetX = 0;
                                        if (series.length === 2) {
                                            const val1 = Number(d[series[0]]) || 0;
                                            const val2 = Number(d[series[1]]) || 0;
                                            const threshold = maxY * 0.01; // 1% threshold for "same" values

                                            if (Math.abs(val1 - val2) < threshold) {
                                                // Values are the same or very close - offset dots
                                                // First series goes left, second goes right (clamped to stay within bounds)
                                                const offsetAmount = 14; // more spacing between overlapping dots
                                                if (idx === 0) {
                                                    offsetX = -offsetAmount;
                                                } else {
                                                    offsetX = offsetAmount;
                                                }
                                            }
                                        }

                                        let x = baseX + offsetX;
                                        // Clamp so dots never cross the left/right graph boundaries,
                                        // while still keeping some horizontal padding inside the chart.
                                        const minX = paddingLeft + stepX * 0.5;
                                        const maxX = paddingLeft + innerWidth - stepX * 0.5;
                                        if (x < minX) x = minX;
                                        if (x > maxX) x = maxX;

                                        const tooltipText = tooltipKey && d[tooltipKey] ? d[tooltipKey] : null;
                                        const value = Number(d[s]) || 0;
                                        const seriesLabel = seriesLabels && seriesLabels[idx] ? seriesLabels[idx] : s;

                                        return (
                                            <g key={i}>
                                                <circle
                                                    cx={x}
                                                    cy={y}
                                                    r="5"
                                                    fill={color}
                                                    stroke="white"
                                                    strokeWidth="1.5"
                                                    style={{ cursor: 'pointer' }}
                                                    onMouseEnter={(e) => {
                                                        const tooltipContent = [];
                                                        if (tooltipText) {
                                                            tooltipContent.push(tooltipText);
                                                        }
                                                        tooltipContent.push(`${seriesLabel}: ${formatValue(value)}`);
                                                        
                                                        // Calculate position relative to container for consistent positioning across themes
                                                        // Account for any transforms or positioning differences in dark theme
                                                        if (containerRef.current && svgRef.current) {
                                                            const containerRect = containerRef.current.getBoundingClientRect();
                                                            const svgRect = svgRef.current.getBoundingClientRect();
                                                            
                                                            // Get mouse position relative to viewport
                                                            const mouseX = e.clientX;
                                                            const mouseY = e.clientY;
                                                            
                                                            // Calculate position relative to container (for position: absolute)
                                                            const relativeX = mouseX - containerRect.left;
                                                            const relativeY = mouseY - containerRect.top;
                                                            
                                                            // Also store viewport coordinates as fallback
                                                            setTooltip({
                                                                text: tooltipContent.join('\n'),
                                                                x: relativeX, // relative to container
                                                                y: relativeY, // relative to container
                                                                clientX: mouseX, // viewport X
                                                                clientY: mouseY  // viewport Y
                                                            });
                                                        } else {
                                                            // Fallback to viewport coordinates
                                                            setTooltip({
                                                                text: tooltipContent.join('\n'),
                                                                x: e.clientX,
                                                                y: e.clientY,
                                                                clientX: e.clientX,
                                                                clientY: e.clientY
                                                            });
                                                        }
                                                    }}
                                                    onMouseLeave={() => setTooltip(null)}
                                                />
                                            </g>
                                        );
                                    })}
                                </g>
                            );
                        })}
                    </svg>
                    {/* Tooltip */}
                    {tooltip && (
                        <Box
                            ref={tooltipRef}
                            sx={{
                                position: 'absolute',
                                left: `${tooltip.x + 10}px`,
                                top: `${tooltip.y - 30}px`,
                                backgroundColor: 'rgba(0, 0, 0, 0.9)',
                                color: 'white',
                                padding: '6px 10px',
                                borderRadius: '4px',
                                fontSize: '0.75rem',
                                pointerEvents: 'none',
                                zIndex: 1000,
                                maxWidth: '250px',
                                lineHeight: '1.4',
                                boxShadow: '0 2px 8px rgba(0, 0, 0, 0.3)',
                                visibility: 'hidden', // Hide until positioned correctly
                                transform: 'none' // Ensure no transforms interfere with positioning
                            }}
                        >
                            {tooltip.text.split('\n').map((line, idx) => (
                                <Box key={idx} sx={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                                    {line}
                                </Box>
                            ))}
                        </Box>
                    )}
                    {/* Legend */}
                    {seriesLabels && seriesLabels.length > 0 && (
                        <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2, mt: 1 }}>
                            {series.map((s, idx) => {
                                const color = colors[idx] || '#1976d2';
                                const label = seriesLabels[idx] || s;
                                return (
                                    <Box key={s} sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                                        <Box sx={{ width: 16, height: 2, backgroundColor: color }} />
                                        <Typography variant="caption" sx={{ fontSize: '0.75rem', color: 'text.secondary' }}>
                                            {label}
                                        </Typography>
                                    </Box>
                                );
                            })}
                        </Box>
                    )}
                </Box>
            );
        }

        // Simple bubble chart for correct/incorrect counts
        const SimpleBubbleChart = ({ data, xKey, correctKey, incorrectKey, height = 180 }) => {
            const theme = useTheme();
            const isDarkMode = theme.palette.mode === 'dark';
            const axisLabelColor = isDarkMode ? "#bbb" : "#666";
            const axisLineColor = isDarkMode ? "#888" : "#999";
            const axisMainLineColor = isDarkMode ? "#666" : "#ccc";
            
            if (!data || data.length === 0) return <Typography variant="body2">No data available</Typography>;
            const width = 520;
            const paddingLeft = 50;
            const paddingRight = 10;
            const paddingTop = 20;
            const paddingBottom = 40;
            const innerWidth = width - paddingLeft - paddingRight;
            const innerHeight = height - paddingTop - paddingBottom;

            const xCount = data.length > 1 ? data.length - 1 : 1;
            const stepX = innerWidth / xCount;

            let maxVal = 0;
            data.forEach(d => {
                maxVal = Math.max(maxVal, Number(d[correctKey]) || 0, Number(d[incorrectKey]) || 0);
            });
            if (maxVal === 0) maxVal = 1;

            const minR = 4;
            const maxR = 18;
            const scaleR = (v) => v <= 0 ? 0 : (minR + (maxR - minR) * (v / maxVal));

            const correctY = paddingTop + innerHeight * 0.35;
            const incorrectY = paddingTop + innerHeight * 0.75;

            // Y-axis ticks for count values
            const yTicks = 5;
            const yTickValues = [];
            for (let i = 0; i <= yTicks; i++) {
                yTickValues.push(Math.round((maxVal / yTicks) * i));
            }

            return (
                <Box>
                    <svg width={width} height={height}>
                        {/* Y-axis */}
                        <line x1={paddingLeft} y1={paddingTop} x2={paddingLeft} y2={paddingTop + innerHeight} stroke={axisMainLineColor} strokeWidth="1" />
                        {/* X-axis */}
                        <line x1={paddingLeft} y1={paddingTop + innerHeight} x2={paddingLeft + innerWidth} y2={paddingTop + innerHeight} stroke={axisMainLineColor} strokeWidth="1" />

                        {/* Y-axis labels */}
                        {yTickValues.map((val, i) => {
                            const y = paddingTop + innerHeight - (i / yTicks) * innerHeight;
                            return (
                                <g key={i}>
                                    <line x1={paddingLeft - 5} y1={y} x2={paddingLeft} y2={y} stroke={axisLineColor} strokeWidth="1" />
                                    <text x={paddingLeft - 8} y={y + 4} textAnchor="end" fontSize="9" fill={axisLabelColor}>
                                        {val}
                                    </text>
                                </g>
                            );
                        })}

                        {/* X-axis labels */}
                        {data.map((d, i) => {
                            const x = paddingLeft + (xCount === 0 ? 0 : i * stepX);
                            return (
                                <g key={i}>
                                    <line x1={x} y1={paddingTop + innerHeight} x2={x} y2={paddingTop + innerHeight + 4} stroke={axisLineColor} />
                                    <text x={x} y={paddingTop + innerHeight + 16} textAnchor="middle" fontSize="10" fill={axisLabelColor}>
                                        {d[xKey]}
                                    </text>
                                </g>
                            );
                        })}

                        {/* Reference lines for correct and incorrect positions */}
                        <line x1={paddingLeft} y1={correctY} x2={paddingLeft + innerWidth} y2={correctY} stroke="#e0e0e0" strokeWidth="1" strokeDasharray="2,2" opacity="0.5" />
                        <line x1={paddingLeft} y1={incorrectY} x2={paddingLeft + innerWidth} y2={incorrectY} stroke="#e0e0e0" strokeWidth="1" strokeDasharray="2,2" opacity="0.5" />

                        {/* bubbles */}
                        {data.map((d, i) => {
                            const x = paddingLeft + (xCount === 0 ? 0 : i * stepX);
                            const cVal = Number(d[correctKey]) || 0;
                            const icVal = Number(d[incorrectKey]) || 0;
                            const rC = scaleR(cVal);
                            const rI = scaleR(icVal);
                            return (
                                <g key={i}>
                                    {rC > 0 && (
                                        <g>
                                            <circle cx={x} cy={correctY} r={rC} fill="#2e7d32" fillOpacity="0.7" stroke="#1b5e20" strokeWidth="1" />
                                            <text x={x} y={correctY} textAnchor="middle" fontSize="9" fill="#fff" fontWeight="bold">
                                                {cVal}
                                            </text>
                                        </g>
                                    )}
                                    {rI > 0 && (
                                        <g>
                                            <circle cx={x} cy={incorrectY} r={rI} fill="#d32f2f" fillOpacity="0.7" stroke="#b71c1c" strokeWidth="1" />
                                            <text x={x} y={incorrectY} textAnchor="middle" fontSize="9" fill="#fff" fontWeight="bold">
                                                {icVal}
                                            </text>
                                        </g>
                                    )}
                                </g>
                            );
                        })}
                    </svg>
                    {/* Legend */}
                    <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2, mt: 1 }}>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                            <Box sx={{ width: 12, height: 12, borderRadius: '50%', backgroundColor: '#2e7d32', opacity: 0.7 }} />
                            <Typography variant="caption" sx={{ fontSize: '0.75rem', color: 'text.secondary' }}>
                                Correct Count
                            </Typography>
                        </Box>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                            <Box sx={{ width: 12, height: 12, borderRadius: '50%', backgroundColor: '#d32f2f', opacity: 0.7 }} />
                            <Typography variant="caption" sx={{ fontSize: '0.75rem', color: 'text.secondary' }}>
                                Incorrect Count
                            </Typography>
                        </Box>
                    </Box>
                </Box>
            );
        }
        //UseEffect to get the first Users Data

        return (
            <Box sx={{ backgroundColor: 'background.default', minHeight: '100vh' }}>
                 <Box sx={{ display: "flex", justifyContent: "right", alignItems: "right", mb: 1 }}>
                            <Button variant="outlined" onClick={startTour}>
                                Take a tour
                            </Button>
                        </Box>
                <Card
                    sx={{
                        border: '1px solid',
                        borderColor: 'divider',
                        boxShadow: (theme) => theme.palette.mode === 'dark'
                            ? '0 4px 16px rgba(0,0,0,0.5), 0 0 0 1px rgba(255,255,255,0.1)'
                            : '0 4px 16px rgba(0,0,0,0.1), 0 0 0 1px rgba(0,0,0,0.05)',
                        backgroundColor: 'background.paper',
                    }}
                >
                    <CardHeader
                        title={
                            <Typography
                                sx={{
                                    fontWeight: 600,
                                    fontSize: '1.125rem',
                                    color: 'text.primary',
                                    letterSpacing: '-0.01em',
                                    textAlign: 'center',
                                    width: '100%'
                                }}
                                variant="h6"
                            >
                                Hello, {user.email}!
                            </Typography>
                        }
                    />
                    <CardContent>
                       
                        <Box
                            ref={selectorRef}
                            display="flex"
                            alignItems="center"
                            justifyContent="center"
                            sx={{
                                marginBottom: "20px",
                                gap: 2,
                                flexWrap: 'wrap',
                                borderRadius: 2,
                                scrollMarginTop: "88px",
                                border: '1px solid',
                                borderColor: tourOpen && tourSections[tourSection]?.targetRef === selectorRef ? 'primary.main' : 'transparent',
                                boxShadow: tourOpen && tourSections[tourSection]?.targetRef === selectorRef ? '0 0 0 3px rgba(25,118,210,0.25)' : 'none',
                                p: 1
                            }}
                        >
                            {!isStudent() && <>
                                <Typography
                                    sx={{
                                        fontWeight: 600,
                                        fontSize: '1rem',
                                        color: 'text.primary',
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: 1
                                    }}
                                >
                                    <PersonIcon sx={{ color: 'primary.main', fontSize: '1.25rem' }} />
                                    Select Student:
                                </Typography>
                                <FormControl
                                    sx={{
                                        minWidth: 280
                                    }}
                                >
                                    <InputLabel
                                        sx={{
                                            fontWeight: 500,
                                            '&.Mui-focused': {
                                                color: 'primary.main'
                                            }
                                        }}
                                    >
                                        Choose Student
                                    </InputLabel>
                                    <Select
                                        value={statsID}
                                        onChange={handleChange}
                                        label="Choose Student"
                                        disabled={overviewDataLoading}
                                        renderValue={(value) => {
                                            const selectedUser = users?.enrolledUsers?.find(u => u.ID === value) || (users?.[0]?.ID === value ? users[0] : null);
                                            return selectedUser ? selectedUser.Username : '';
                                        }}
                                        MenuProps={{
                                            PaperProps: {
                                                sx: {
                                                    borderRadius: 2,
                                                    marginTop: 1,
                                                    boxShadow: '0 8px 24px rgba(0,0,0,0.12)',
                                                    border: '1px solid',
                                                    borderColor: 'divider',
                                                    '& .MuiMenuItem-root': {
                                                        borderRadius: 1,
                                                        margin: '4px 8px',
                                                        padding: '10px 16px',
                                                        '&:hover': {
                                                            backgroundColor: 'action.hover',
                                                        },
                                                        '&.Mui-selected': {
                                                            backgroundColor: 'primary.light',
                                                            color: 'primary.contrastText',
                                                            '&:hover': {
                                                                backgroundColor: 'primary.main',
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        }}
                                    >
                                        {users && users.enrolledUsers && users.enrolledUsers.map((row) => (
                                                <MenuItem
                                                    key={row.ID}
                                                    value={row.ID}
                                                    sx={{
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        gap: 1
                                                    }}
                                                >
                                                    <PersonIcon sx={{ fontSize: '1.1rem', opacity: 0.7 }} />
                                                    <Box>
                                                        <Typography variant="body1" sx={{ fontWeight: 500 }}>
                                                            {row.Username}
                                                        </Typography>
                                                        {row.EmailId && (
                                                            <Typography variant="caption" sx={{ color: 'text.secondary', display: 'block' }}>
                                                                {row.EmailId}
                                                            </Typography>
                                                        )}
                                                    </Box>
                                                </MenuItem>
                                        ))}
                                        {users && users[0] && (users[0].IsActive || users[0].isTrial) && (
                                            <MenuItem
                                                value={users[0].ID}
                                                sx={{
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    gap: 1
                                                }}
                                            >
                                                <PersonIcon sx={{ fontSize: '1.1rem', opacity: 0.7 }} />
                                                <Box>
                                                    <Typography variant="body1" sx={{ fontWeight: 500 }}>
                                                        {users[0].Username}
                                                    </Typography>
                                                </Box>
                                            </MenuItem>
                                        )}
                                    </Select>
                                </FormControl>
                            </>
                            }
                        </Box>
                        <AsyncSection loading={overviewDataLoading} minHeight={480}>
                        <Grid2 container spacing={2}>
                            <Grid2 size={{ xs: 12, sm: 8, md: 6 }}>
                                <Box
                                    ref={medalsRef}
                                    sx={{
                                        margin: "5px",
                                        scrollMarginTop: "88px",
                                        borderRadius: 4,
                                        border: "1px solid",
                                        borderColor: tourOpen && tourSections[tourSection]?.targetRef === medalsRef ? "primary.main" : "divider",
                                        outline: tourOpen && tourSections[tourSection]?.targetRef === medalsRef ? "3px solid rgba(25,118,210,0.25)" : "none",
                                        overflow: "hidden",
                                        backgroundColor: "background.paper",
                                    }}
                                >
                                <Card
                                    elevation={6}
                                    sx={{
                                        minHeight: "428px",
                                        maxHeight: "428px",
                                        borderRadius: 0,
                                        margin: 0,
                                        overflow: 'auto',
                                        border: 'none',
                                        backgroundColor: 'background.paper',
                                        boxShadow: (theme) => theme.palette.mode === 'dark'
                                            ? '0 4px 16px rgba(0,0,0,0.5), 0 0 0 1px rgba(255,255,255,0.1)'
                                            : '0 4px 16px rgba(0,0,0,0.1), 0 0 0 1px rgba(0,0,0,0.05)',
                                    }}
                                >
                                    <CardHeader
                                        sx={{
                                            top: 0,
                                            zIndex: 1,
                                            position: 'sticky',
                                            pb: 1,
                                            textAlign: 'center',
                                        }}
                                        title={
                                            <Typography
                                                sx={{
                                                    fontWeight: 600,
                                                    fontSize: '1.125rem',
                                                    color: 'text.primary',
                                                    letterSpacing: '-0.01em',
                                                    textAlign: 'center',
                                                    width: '100%'
                                                }}
                                                variant="h6"
                                            >
                                                Medals
                                            </Typography>
                                        }
                                    />
                                    <CardContent>
                                        <Box display="flex" justifyContent="center" alignItems="center" sx={{ paddingTop: "0px" }}>
                                            <Grid2 container spacing={5}>
                                                <Grid2 size={{ xs: 12, sm: 8, md: 6, lg: 4 }}>
                                                    <Card
                                                        sx={{
                                                            height: '100%',
                                                            display: 'flex',
                                                            flexDirection: 'column',
                                                            position: 'relative',
                                                            transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                                                            backgroundColor: 'background.paper',
                                                            border: '1px solid',
                                                            borderColor: 'divider',
                                                            boxShadow: (theme) => theme.palette.mode === 'dark'
                                                                ? '0 2px 8px rgba(0,0,0,0.5), 0 0 0 1px rgba(255,255,255,0.1)'
                                                                : '0 2px 8px rgba(0,0,0,0.08), 0 0 0 1px rgba(0,0,0,0.04)',
                                                            '&:hover': {
                                                                boxShadow: (theme) => theme.palette.mode === 'dark'
                                                                    ? '0 8px 24px rgba(0,0,0,0.7), 0 0 0 1px rgba(255,255,255,0.15)'
                                                                    : '0 8px 24px rgba(0,0,0,0.12), 0 0 0 1px rgba(0,0,0,0.06)',
                                                                transform: 'translateY(-4px) scale(1.02)',
                                                            },
                                                        }}
                                                    >
                                                        <CardContent>
                                                            <Stack>
                                                                <Box display="flex" justifyContent="center" alignItems="center">
                                                                    {GoldMedal}
                                                                </Box>
                                                                <Box display="flex" justifyContent="center" alignItems="center">
                                                                    Gold&nbsp; - {medalStats.Gold || 0}
                                                                </Box>
                                                            </Stack>
                                                        </CardContent>
                                                    </Card>
                                                </Grid2>
                                                <Grid2 size={{ xs: 12, sm: 8, md: 6, lg: 4 }}>
                                                    <Card
                                                        sx={{
                                                            height: '100%',
                                                            display: 'flex',
                                                            flexDirection: 'column',
                                                            position: 'relative',
                                                            transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                                                            backgroundColor: 'background.paper',
                                                            border: '1px solid',
                                                            borderColor: 'divider',
                                                            boxShadow: (theme) => theme.palette.mode === 'dark'
                                                                ? '0 2px 8px rgba(0,0,0,0.5), 0 0 0 1px rgba(255,255,255,0.1)'
                                                                : '0 2px 8px rgba(0,0,0,0.08), 0 0 0 1px rgba(0,0,0,0.04)',
                                                            '&:hover': {
                                                                boxShadow: (theme) => theme.palette.mode === 'dark'
                                                                    ? '0 8px 24px rgba(0,0,0,0.7), 0 0 0 1px rgba(255,255,255,0.15)'
                                                                    : '0 8px 24px rgba(0,0,0,0.12), 0 0 0 1px rgba(0,0,0,0.06)',
                                                                transform: 'translateY(-4px) scale(1.02)',
                                                            },
                                                        }}
                                                    >
                                                        <CardContent>
                                                            <Stack>
                                                                <Box display="flex" justifyContent="center" alignItems="center">
                                                                    {SilverMedal}
                                                                </Box>
                                                                <Box display="flex" justifyContent="center" alignItems="center">
                                                                    Silver&nbsp; - {medalStats.Silver || 0}
                                                                </Box>
                                                            </Stack>
                                                        </CardContent>
                                                    </Card>
                                                </Grid2>
                                                <Grid2 size={{ xs: 12, sm: 8, md: 6, lg: 4 }}>
                                                    <Card
                                                        sx={{
                                                            height: '100%',
                                                            display: 'flex',
                                                            flexDirection: 'column',
                                                            position: 'relative',
                                                            transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                                                            backgroundColor: 'background.paper',
                                                            border: '1px solid',
                                                            borderColor: 'divider',
                                                            boxShadow: (theme) => theme.palette.mode === 'dark'
                                                                ? '0 2px 8px rgba(0,0,0,0.5), 0 0 0 1px rgba(255,255,255,0.1)'
                                                                : '0 2px 8px rgba(0,0,0,0.08), 0 0 0 1px rgba(0,0,0,0.04)',
                                                            '&:hover': {
                                                                boxShadow: (theme) => theme.palette.mode === 'dark'
                                                                    ? '0 8px 24px rgba(0,0,0,0.7), 0 0 0 1px rgba(255,255,255,0.15)'
                                                                    : '0 8px 24px rgba(0,0,0,0.12), 0 0 0 1px rgba(0,0,0,0.06)',
                                                                transform: 'translateY(-4px) scale(1.02)',
                                                            },
                                                        }}
                                                    >
                                                        <CardContent>
                                                            <Stack>
                                                                <Box display="flex" justifyContent="center" alignItems="center">
                                                                    {BronzeMedal}
                                                                </Box>
                                                                <Box display="flex" justifyContent="center" alignItems="center">
                                                                    Bronze&nbsp; - {medalStats.Bronze || 0}
                                                                </Box>
                                                            </Stack>
                                                        </CardContent>
                                                    </Card>
                                                </Grid2>
                                            </Grid2>
                                        </Box>
                                    </CardContent>
                                </Card>
                                </Box>
                            </Grid2>
                            <Grid2 size={{ xs: 12, sm: 8, md: 6 }}>
                                <Box
                                    ref={attemptsRef}
                                    sx={{
                                        margin: "5px",
                                        scrollMarginTop: "88px",
                                        borderRadius: 4,
                                        border: "1px solid",
                                        borderColor: tourOpen && tourSections[tourSection]?.targetRef === attemptsRef ? "primary.main" : "divider",
                                        outline: tourOpen && tourSections[tourSection]?.targetRef === attemptsRef ? "3px solid rgba(25,118,210,0.25)" : "none",
                                        overflow: "hidden",
                                        backgroundColor: "background.paper",
                                    }}
                                >
                                <Card
                                    elevation={6}
                                    sx={{
                                        minHeight: "428px",
                                        maxHeight: "428px",
                                        borderRadius: 0,
                                        margin: 0,
                                        overflow: 'hidden',
                                        display: 'flex',
                                        flexDirection: 'column',
                                        border: 'none',
                                        backgroundColor: 'background.paper',
                                        boxShadow: (theme) => theme.palette.mode === 'dark'
                                            ? '0 4px 16px rgba(0,0,0,0.5), 0 0 0 1px rgba(255,255,255,0.1)'
                                            : '0 4px 16px rgba(0,0,0,0.1), 0 0 0 1px rgba(0,0,0,0.05)',
                                    }}
                                >
                                    <CardHeader
                                        sx={{
                                            pb: 1,
                                            textAlign: 'center',
                                        }}
                                        title={
                                            <Typography
                                                sx={{
                                                    fontWeight: 600,
                                                    fontSize: '1.125rem',
                                                    color: 'text.primary',
                                                    letterSpacing: '-0.01em',
                                                    textAlign: 'center',
                                                    width: '100%'
                                                }}
                                                variant="h6"
                                            >
                                                Latest 5 Attempts
                                            </Typography>
                                        }
                                    />
                                    <CardContent sx={{ flex: 1, overflow: 'auto', p: '0 12px 12px 12px', '&:last-child': { pb: '12px' } }}>
                                        <Box
                                            sx={{
                                                borderRadius: '0 0 8px 8px',
                                                overflow: 'hidden',
                                                height: '100%'
                                            }}
                                        >
                                            <Table stickyHeader>
                                                <TableHead>
                                                    <TableRow>
                                                        <StyledTableCell
                                                            sx={{
                                                                borderTopLeftRadius: '8px',
                                                                '&:first-of-type': {
                                                                    borderTopLeftRadius: '8px'
                                                                }
                                                            }}
                                                        >
                                                            Subject
                                                        </StyledTableCell>
                                                        <StyledTableCell>
                                                            Score
                                                        </StyledTableCell>
                                                        <StyledTableCell
                                                            sx={{
                                                                borderTopRightRadius: '8px',
                                                                '&:last-of-type': {
                                                                    borderTopRightRadius: '8px'
                                                                }
                                                            }}
                                                        >
                                                            Review
                                                        </StyledTableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {userStats && userStats.UserLatestAttempts && userStats.UserLatestAttempts.length > 0 ? (
                                                        userStats.UserLatestAttempts.map((row, idx) => {
                                                            const isLast = idx === userStats.UserLatestAttempts.length - 1;
                                                            return (
                                                                <StyledTableRow key={idx}>
                                                                    <StyledTableCell
                                                                        sx={isLast ? {
                                                                            borderBottomLeftRadius: '8px',
                                                                            paddingBottom: '20px !important',
                                                                            paddingLeft: '16px !important',
                                                                            paddingTop: '16px'
                                                                        } : {
                                                                            paddingLeft: '16px',
                                                                            paddingTop: '16px'
                                                                        }}
                                                                    >
                                                                        {row.Subject}
                                                                    </StyledTableCell>
                                                                    <StyledTableCell
                                                                        sx={isLast ? {
                                                                            paddingBottom: '20px !important',
                                                                            paddingTop: '16px'
                                                                        } : { paddingTop: '16px' }}
                                                                    >
                                                                        {row.Score}
                                                                    </StyledTableCell>
                                                                    <StyledTableCell
                                                                        sx={isLast ? {
                                                                            borderBottomRightRadius: '8px',
                                                                            paddingBottom: '20px !important',
                                                                            paddingRight: '16px !important',
                                                                            paddingTop: '16px'
                                                                        } : {
                                                                            paddingRight: '16px',
                                                                            paddingTop: '16px'
                                                                        }}
                                                                    >
                                                                        <Button type="submit"
                                                                            sx={{
                                                                                textTransform: "initial",
                                                                                marginBottom: "10px",
                                                                                "&:hover": { backgroundColor: "primary.main", color: "primary.contrastText" }
                                                                            }}
                                                                            fullWidth
                                                                            variant="outlined"
                                                                            color="primary"
                                                                            onClick={() => { navigate('/app/practice/review/' + row.AssessmentID + '/' + statsID, { replace: false }) }} >
                                                                            <PreviewIcon /> Review
                                                                        </Button>
                                                                    </StyledTableCell>
                                                                </StyledTableRow>
                                                            );
                                                        })
                                                    ) : (
                                                        <StyledTableRow>
                                                            <StyledTableCell colSpan={3} sx={{ textAlign: 'center', py: 3 }}>
                                                                No attempts yet
                                                            </StyledTableCell>
                                                        </StyledTableRow>
                                                    )}
                                                </TableBody>
                                            </Table>
                                        </Box>
                                    </CardContent>
                                </Card>
                                </Box>
                            </Grid2>
                        </Grid2>
                        <br></br>



                        <Box
                            ref={practiceSummaryRef}
                            sx={{
                                margin: "5px",
                                scrollMarginTop: "88px",
                                borderRadius: 4,
                                border: "1px solid",
                                borderColor: tourOpen && tourSections[tourSection]?.targetRef === practiceSummaryRef ? "primary.main" : "divider",
                                outline: tourOpen && tourSections[tourSection]?.targetRef === practiceSummaryRef ? "3px solid rgba(25,118,210,0.25)" : "none",
                                overflow: "hidden",
                                backgroundColor: "background.paper",
                            }}
                        >
                        <Card
                            elevation={6}
                            sx={{
                                borderRadius: 0,
                                margin: 0,
                                overflow: 'hidden',
                                border: 'none',
                                backgroundColor: 'background.paper',
                                boxShadow: (theme) => theme.palette.mode === 'dark'
                                    ? '0 4px 16px rgba(0,0,0,0.5), 0 0 0 1px rgba(255,255,255,0.1)'
                                    : '0 4px 16px rgba(0,0,0,0.1), 0 0 0 1px rgba(0,0,0,0.05)',
                            }}
                        >
                            <CardHeader
                                sx={{
                                    pb: 1,
                                    textAlign: 'center',
                                }}
                                title={
                                    <Typography
                                        sx={{
                                            fontWeight: 600,
                                            fontSize: '1.125rem',
                                            color: 'text.primary',
                                            letterSpacing: '-0.01em',
                                            textAlign: 'center',
                                            width: '100%'
                                        }}
                                        variant="h6"
                                    >
                                        Practice Summary
                                    </Typography>
                                }
                            />
                            <CardContent sx={{ p: '0 12px 12px 12px', '&:last-child': { pb: '12px' } }}>
                                <Box sx={{
                                    borderRadius: '0 0 8px 8px',
                                    overflow: 'hidden'
                                }}>
                                    <Table>
                                        <TableHead>
                                            <TableRow>
                                                <StyledTableCell
                                                    sx={{
                                                        borderTopLeftRadius: '8px',
                                                        '&:first-of-type': {
                                                            borderTopLeftRadius: '8px'
                                                        }
                                                    }}
                                                >
                                                    Subject
                                                </StyledTableCell>
                                                <StyledTableCell>Total Attempted</StyledTableCell>
                                                <StyledTableCell>Total Pending</StyledTableCell>
                                                <StyledTableCell>Avg Score</StyledTableCell>
                                                <StyledTableCell
                                                    sx={{
                                                        borderTopRightRadius: '8px',
                                                        '&:last-of-type': {
                                                            borderTopRightRadius: '8px'
                                                        }
                                                    }}
                                                >
                                                    Max Score
                                                </StyledTableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {assessmentSummaryStats && assessmentSummaryStats.Stats && assessmentSummaryStats.Stats.length > 0 ? (
                                                assessmentSummaryStats.Stats.map((row, idx) => {
                                                    const isLast = idx === assessmentSummaryStats.Stats.length - 1;
                                                    return (
                                                        <StyledTableRow key={idx}>
                                                            <StyledTableCell
                                                                sx={isLast ? {
                                                                    borderBottomLeftRadius: '8px',
                                                                    paddingBottom: '20px !important',
                                                                    paddingLeft: '16px !important',
                                                                    paddingTop: '16px'
                                                                } : {
                                                                    paddingLeft: '16px',
                                                                    paddingTop: '16px'
                                                                }}
                                                            >
                                                                {row.Subject}
                                                            </StyledTableCell>
                                                            <StyledTableCell
                                                                sx={isLast ? {
                                                                    paddingBottom: '20px !important',
                                                                    paddingTop: '16px'
                                                                } : { paddingTop: '16px' }}
                                                            >
                                                                {row.TotalAttempted || 0}
                                                            </StyledTableCell>
                                                            <StyledTableCell
                                                                sx={isLast ? {
                                                                    paddingBottom: '20px !important',
                                                                    paddingTop: '16px'
                                                                } : { paddingTop: '16px' }}
                                                            >
                                                                {row.TotalPending || 0}
                                                            </StyledTableCell>
                                                            <StyledTableCell
                                                                sx={isLast ? {
                                                                    paddingBottom: '20px !important',
                                                                    paddingTop: '16px'
                                                                } : { paddingTop: '16px' }}
                                                            >
                                                                {row.AverageScore ? row.AverageScore.toFixed(2) : '0.00'}
                                                            </StyledTableCell>
                                                            <StyledTableCell
                                                                sx={isLast ? {
                                                                    borderBottomRightRadius: '8px',
                                                                    paddingBottom: '20px !important',
                                                                    paddingRight: '16px !important',
                                                                    paddingTop: '16px'
                                                                } : {
                                                                    paddingRight: '16px',
                                                                    paddingTop: '16px'
                                                                }}
                                                            >
                                                                {row.MaxScore ? row.MaxScore.toFixed(2) : '0.00'}
                                                            </StyledTableCell>
                                                        </StyledTableRow>
                                                    );
                                                })
                                            ) : (
                                                <StyledTableRow>
                                                    <StyledTableCell colSpan={5} sx={{ textAlign: 'center', py: 3 }}>
                                                        No practice data available
                                                    </StyledTableCell>
                                                </StyledTableRow>
                                            )}
                                        </TableBody>
                                    </Table>
                                </Box>
                            </CardContent>

                        </Card>
                        </Box>
                        <br></br>
                        <Card
                            elevation={6}
                            sx={{
                                display: "none",
                                borderRadius: 4,
                                margin: "5px",
                                overflow: 'hidden',
                                border: '1px solid',
                                borderColor: 'divider',
                                backgroundColor: 'background.paper',
                                boxShadow: (theme) => theme.palette.mode === 'dark'
                                    ? '0 4px 16px rgba(0,0,0,0.5), 0 0 0 1px rgba(255,255,255,0.1)'
                                    : '0 4px 16px rgba(0,0,0,0.1), 0 0 0 1px rgba(0,0,0,0.05)'
                            }}
                        >
                            <CardHeader
                                sx={{
                                    pb: 1,
                                    textAlign: 'center',
                                }}
                                title={
                                    <Typography
                                        sx={{
                                            fontWeight: 600,
                                            fontSize: '1.125rem',
                                            color: 'text.primary',
                                            letterSpacing: '-0.01em',
                                            textAlign: 'center',
                                            width: '100%'
                                        }}
                                        variant="h6"
                                    >
                                        Response Stats
                                    </Typography>
                                }
                            />
                            <CardContent sx={{ p: '0 12px 12px 12px', '&:last-child': { pb: '12px' } }}>
                                <Box sx={{
                                    borderRadius: '0 0 8px 8px',
                                    overflow: 'hidden'
                                }}>
                                    <Table>
                                        <TableHead>
                                            <TableRow>
                                                <StyledTableCell
                                                    sx={{
                                                        borderTopLeftRadius: '8px',
                                                        '&:first-of-type': {
                                                            borderTopLeftRadius: '8px'
                                                        }
                                                    }}
                                                >
                                                    Subject
                                                </StyledTableCell>
                                                <StyledTableCell>Category</StyledTableCell>
                                                <StyledTableCell>Response</StyledTableCell>
                                                <StyledTableCell
                                                    sx={{
                                                        borderTopRightRadius: '8px',
                                                        '&:last-of-type': {
                                                            borderTopRightRadius: '8px'
                                                        }
                                                    }}
                                                >
                                                    Avg Time Taken
                                                </StyledTableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {userResponseStats && userResponseStats.ResponseStatList && userResponseStats.ResponseStatList.length > 0 ? (
                                                userResponseStats.ResponseStatList.map((row, idx) => {
                                                    const isLast = idx === userResponseStats.ResponseStatList.length - 1;
                                                    return (
                                                        <StyledTableRow key={idx}>
                                                            <StyledTableCell
                                                                sx={isLast ? {
                                                                    borderBottomLeftRadius: '8px',
                                                                    paddingBottom: '20px !important',
                                                                    paddingLeft: '16px !important',
                                                                    paddingTop: '16px'
                                                                } : {
                                                                    paddingLeft: '16px',
                                                                    paddingTop: '16px'
                                                                }}
                                                            >
                                                                {row.Qsubject}
                                                            </StyledTableCell>
                                                            <StyledTableCell
                                                                sx={isLast ? {
                                                                    paddingBottom: '20px !important',
                                                                    paddingTop: '16px'
                                                                } : { paddingTop: '16px' }}
                                                            >
                                                                {row.Qcategory}
                                                            </StyledTableCell>
                                                            {row.Rstatus ?
                                                                <StyledTableCell
                                                                    sx={isLast ? {
                                                                        paddingBottom: '20px !important',
                                                                        paddingTop: '16px'
                                                                    } : { paddingTop: '16px' }}
                                                                >
                                                                    Correct
                                                                </StyledTableCell>
                                                                :
                                                                <StyledTableCell
                                                                    sx={isLast ? {
                                                                        paddingBottom: '20px !important',
                                                                        paddingTop: '16px'
                                                                    } : { paddingTop: '16px' }}
                                                                >
                                                                    Incorrect
                                                                </StyledTableCell>
                                                            }
                                                            <StyledTableCell
                                                                sx={isLast ? {
                                                                    borderBottomRightRadius: '8px',
                                                                    paddingBottom: '20px !important',
                                                                    paddingRight: '16px !important',
                                                                    paddingTop: '16px'
                                                                } : {
                                                                    paddingRight: '16px',
                                                                    paddingTop: '16px'
                                                                }}
                                                            >
                                                                <Typography component="span" sx={{ color: 'text.primary' }}>{String(Math.floor(row.Avg / 3600)).padStart(2, '0')}:</Typography>
                                                                <Typography component="span" sx={{ color: 'text.primary' }}>{String(Math.floor((row.Avg % 3600) / 60)).padStart(2, '0')}:</Typography>
                                                                <Typography component="span" sx={{ color: 'text.primary' }}>{String(Math.floor(row.Avg % 60)).padStart(2, '0')}</Typography>
                                                            </StyledTableCell>
                                                        </StyledTableRow>
                                                    );
                                                })
                                            ) : (
                                                <StyledTableRow>
                                                    <StyledTableCell colSpan={7} sx={{ textAlign: 'center', py: 3 }}>
                                                        No response data available
                                                    </StyledTableCell>
                                                </StyledTableRow>
                                            )}
                                        </TableBody>
                                    </Table>
                                </Box>
                            </CardContent>

                        </Card>
                        <br></br>
                        <Box
                            ref={trendAnalysisRef}
                            sx={{
                                margin: "5px",
                                scrollMarginTop: "88px",
                                borderRadius: 4,
                                border: "1px solid",
                                borderColor: tourOpen && tourSections[tourSection]?.targetRef === trendAnalysisRef ? "primary.main" : "divider",
                                outline: tourOpen && tourSections[tourSection]?.targetRef === trendAnalysisRef ? "3px solid rgba(25,118,210,0.25)" : "none",
                                overflow: "hidden",
                                backgroundColor: "background.paper",
                            }}
                        >
                        <Card
                            elevation={6}
                            sx={{
                                borderRadius: 0,
                                margin: 0,
                                overflow: "hidden",
                                border: "none",
                                boxShadow: (theme) => theme.palette.mode === "dark"
                                    ? "0 4px 16px rgba(0,0,0,0.5), 0 0 0 1px rgba(255,255,255,0.1)"
                                    : "0 4px 16px rgba(0,0,0,0.1), 0 0 0 1px rgba(0,0,0,0.05)",
                                backgroundColor: "background.paper",
                            }}
                        >
                            <CardHeader
                                sx={{
                                    textAlign: "center",
                                    pb: 1,
                                }}
                                title={
                                    <Typography
                                        variant="h6"
                                        sx={{
                                            fontWeight: 600,
                                            fontSize: "1.125rem",
                                            color: "text.primary",
                                            textAlign: "center",
                                            width: "100%",
                                        }}
                                    >
                                        Trend Analysis
                                    </Typography>
                                }
                            />
                            <CardContent sx={{ px: { xs: 2, sm: 3 }, pb: 3, pt: 2, "&:last-child": { pb: 3 } }}>
                                {attemptedSubjects && attemptedSubjects.length > 0 && (
                                    <Box
                                        sx={{
                                            textAlign: "center",
                                            pb: 3,
                                            mb: 2,
                                            borderBottom: "1px solid",
                                            borderColor: "divider",
                                        }}
                                    >
                                        <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 0.5 }}>
                                            Filters
                                        </Typography>
                                        <Typography variant="body2" color="text.secondary" sx={{ mb: 2, maxWidth: 520, mx: "auto" }}>
                                            Choose subject and category for analysis.
                                        </Typography>
                                        <Stack
                                            direction={{ xs: "column", sm: "row" }}
                                            spacing={2}
                                            justifyContent="center"
                                            alignItems="center"
                                            flexWrap="wrap"
                                            useFlexGap
                                        >
                                            <FormControl size="small" sx={{ minWidth: { xs: "100%", sm: 200 }, maxWidth: 280, mx: "auto" }}>
                                                <InputLabel>Subject</InputLabel>
                                                <Select
                                                    value={selectedSubject}
                                                    label="Subject"
                                                    onChange={handleSubjectChange}
                                                    disabled={overviewDataLoading}
                                                >
                                                    {attemptedSubjects.map((s) => (
                                                        <MenuItem key={s} value={s}>{s}</MenuItem>
                                                    ))}
                                                </Select>
                                            </FormControl>
                                            {availableCategories && availableCategories.length > 0 && (
                                                <FormControl size="small" sx={{ minWidth: { xs: "100%", sm: 200 }, maxWidth: 280, mx: "auto" }}>
                                                    <InputLabel>Category</InputLabel>
                                                    <Select
                                                        value={selectedCategory}
                                                        label="Category"
                                                        onChange={(e) => setSelectedCategory(e.target.value)}
                                                    >
                                                        {availableCategories.map((c) => (
                                                            <MenuItem key={c} value={c}>
                                                                {c === "__overall" ? "Overall" : c}
                                                            </MenuItem>
                                                        ))}
                                                    </Select>
                                                </FormControl>
                                            )}
                                        </Stack>
                                    </Box>
                                )}
                                {!isThisStudent && selectedSubject && (
                                    <Box
                                        ref={aiInsightRef}
                                        sx={{
                                            mb: 2,
                                            scrollMarginTop: "88px",
                                            borderRadius: 4,
                                            border: "1px solid",
                                            borderColor: tourOpen && tourSections[tourSection]?.targetRef === aiInsightRef ? "primary.main" : "divider",
                                            outline: tourOpen && tourSections[tourSection]?.targetRef === aiInsightRef ? "3px solid rgba(25,118,210,0.25)" : "none",
                                            overflow: "hidden",
                                            backgroundColor: "background.paper",
                                        }}
                                    >
                                    <Card
                                        elevation={3}
                                        sx={{
                                            borderRadius: 0,
                                            mb: 0,
                                            overflow: "hidden",
                                            border: "none",
                                            backgroundColor: "background.paper",
                                        }}
                                    >
                                        <CardHeader
                                            sx={{ pb: 1, textAlign: "center" }}
                                            title={
                                                <Typography
                                                    sx={{
                                                        fontWeight: 600,
                                                        fontSize: "1.125rem",
                                                        color: "text.primary",
                                                        letterSpacing: "-0.01em",
                                                        textAlign: "center",
                                                        width: "100%",
                                                    }}
                                                    variant="h6"
                                                >
                                                    AI Insight
                                                </Typography>
                                            }
                                        />
                                        <CardContent sx={{ pt: 1.5 }}>
                                            {aiAnalysisLoading ? (
                                                <Stack direction="row" spacing={1} alignItems="center">
                                                    <CircularProgress size={18} />
                                                    <Typography variant="body2" color="text.secondary">
                                                        Generating analysis...
                                                    </Typography>
                                                </Stack>
                                            ) : aiAnalysisError ? (
                                                <Typography variant="body2" color="error.main">
                                                    {aiAnalysisError}
                                                </Typography>
                                            ) : (
                                                <Box
                                                    sx={{
                                                        color: "text.secondary",
                                                        fontSize: "0.875rem",
                                                        lineHeight: 1.65,
                                                        "& p": { margin: "0.4em 0" },
                                                        "& p:first-of-type": { marginTop: 0 },
                                                        "& p:last-of-type": { marginBottom: 0 },
                                                        "& ul, & ol": { pl: 2.5, my: 1 },
                                                        "& li": { mb: 0.35 },
                                                        "& strong": { fontWeight: 600, color: "text.primary" },
                                                        "& a": { color: "primary.main", wordBreak: "break-word" },
                                                        "& h1, & h2, & h3, & h4": {
                                                            fontWeight: 600,
                                                            color: "text.primary",
                                                            mt: 1.25,
                                                            mb: 0.75,
                                                        },
                                                        "& h1": { fontSize: "1.125rem" },
                                                        "& h2": { fontSize: "1.05rem" },
                                                        "& h3, & h4": { fontSize: "1rem" },
                                                        "& code": {
                                                            fontFamily: "ui-monospace, monospace",
                                                            bgcolor: "action.hover",
                                                            px: 0.5,
                                                            py: 0.15,
                                                            borderRadius: 0.5,
                                                            fontSize: "0.8125rem",
                                                        },
                                                        "& pre": {
                                                            bgcolor: "action.hover",
                                                            p: 1.5,
                                                            borderRadius: 1,
                                                            overflow: "auto",
                                                            my: 1,
                                                            maxWidth: "100%",
                                                            "& code": { bgcolor: "transparent", p: 0 },
                                                        },
                                                        "& table": {
                                                            width: "100%",
                                                            borderCollapse: "collapse",
                                                            my: 1,
                                                            display: "block",
                                                            overflowX: "auto",
                                                        },
                                                        "& th, & td": {
                                                            border: "1px solid",
                                                            borderColor: "divider",
                                                            p: 1,
                                                            textAlign: "left",
                                                            verticalAlign: "top",
                                                        },
                                                        "& th": { bgcolor: "action.hover", fontWeight: 600 },
                                                        "& blockquote": {
                                                            borderLeft: "4px solid",
                                                            borderColor: "primary.main",
                                                            pl: 2,
                                                            my: 1,
                                                            color: "text.secondary",
                                                        },
                                                        "& hr": { borderColor: "divider", my: 2 },
                                                    }}
                                                >
                                                    <ReactMarkdown remarkPlugins={[remarkGfm]}>
                                                        {aiAnalysis.trim()
                                                            ? aiAnalysis
                                                            : "Analysis will appear here once available."}
                                                    </ReactMarkdown>
                                                </Box>
                                            )}
                                        </CardContent>
                                    </Card>
                                    </Box>
                                )}
                                <Stack spacing={2}>
                        {/* New subject-based line charts using userMgmt stats APIs */}
                        <Box
                            ref={accuracyRef}
                            sx={{
                                scrollMarginTop: "88px",
                                borderRadius: 4,
                                border: "1px solid",
                                borderColor: tourOpen && tourSections[tourSection]?.targetRef === accuracyRef ? "primary.main" : "divider",
                                outline: tourOpen && tourSections[tourSection]?.targetRef === accuracyRef ? "3px solid rgba(25,118,210,0.25)" : "none",
                                overflow: "hidden",
                                backgroundColor: "background.paper",
                            }}
                        >
                        <Card
                            elevation={3}
                            sx={{
                                borderRadius: 0,
                                margin: 0,
                                overflow: 'hidden',
                                border: 'none',
                                backgroundColor: 'background.paper',
                            }}
                        >
                            <CardHeader
                                sx={{
                                    pb: 1,
                                    textAlign: 'center',
                                }}
                                title={
                                    <Typography
                                        sx={{
                                            fontWeight: 600,
                                            fontSize: '1.125rem',
                                            color: 'text.primary',
                                            letterSpacing: '-0.01em',
                                            textAlign: 'center',
                                            width: '100%'
                                        }}
                                        variant="h6"
                                    >
                                        Accuracy (Counts)
                                    </Typography>
                                }
                            />
                            <CardContent>
                                <Typography variant="subtitle2" sx={{ mb: 1 }}>
                                    Correct vs incorrect over assessment attempts
                                </Typography>
                                {(() => {
                                    const cat = selectedCategory || "__overall";
                                    const filtered = (subjectCategoryStats || []).filter(r => r.Category === cat)
                                        .sort((a, b) => (a.AttemptDate || "").localeCompare(b.AttemptDate || ""));
                                    const chartData = filtered.map(r => ({
                                        date: formatDateOnly(r.AttemptDate),
                                        correct: r.CorrectCount,
                                        incorrect: r.IncorrectCount,
                                        aname: r.Aname || "",
                                    }));
                                    return (
                                        <SimpleLineChart
                                            data={chartData}
                                            xKey="date"
                                            series={["correct", "incorrect"]}
                                            colors={["#2e7d32", "#d32f2f"]}
                                            seriesLabels={["Correct Count", "Incorrect Count"]}
                                            formatYValue={(v) => Math.round(v).toString()}
                                            tooltipKey="aname"
                                        />
                                    );
                                })()}
                            </CardContent>
                        </Card>
                        </Box>
                        {/* Speed line charts using userMgmt stats APIs */}
                        <Box
                            ref={speedRef}
                            sx={{
                                scrollMarginTop: "88px",
                                borderRadius: 4,
                                border: "1px solid",
                                borderColor: tourOpen && tourSections[tourSection]?.targetRef === speedRef ? "primary.main" : "divider",
                                outline: tourOpen && tourSections[tourSection]?.targetRef === speedRef ? "3px solid rgba(25,118,210,0.25)" : "none",
                                overflow: "hidden",
                                backgroundColor: "background.paper",
                            }}
                        >
                        <Card
                            elevation={3}
                            sx={{
                                borderRadius: 0,
                                margin: 0,
                                overflow: 'hidden',
                                border: 'none',
                                backgroundColor: 'background.paper',
                            }}
                        >
                            <CardHeader
                                sx={{
                                    pb: 1,
                                    textAlign: 'center',
                                }}
                                title={
                                    <Typography
                                        sx={{
                                            fontWeight: 600,
                                            fontSize: '1.125rem',
                                            color: 'text.primary',
                                            letterSpacing: '-0.01em',
                                            textAlign: 'center',
                                            width: '100%'
                                        }}
                                        variant="h6"
                                    >
                                        Speed (Time)
                                    </Typography>
                                }
                            />
                            <CardContent>
                                <Typography variant="subtitle2" sx={{ mb: 1 }}>
                                    Average time for correct vs incorrect responses
                                </Typography>
                                {(() => {
                                    const cat = selectedCategory || "__overall";
                                    const overall = (subjectCategoryTimeStats || []).filter(r => r.Category === cat)
                                        .sort((a, b) => (a.AttemptDate || "").localeCompare(b.AttemptDate || ""));
                                    const chartData = overall.map(r => ({
                                        date: formatDateOnly(r.AttemptDate),
                                        correct: r.CorrectAvgTime,
                                        incorrect: r.IncorrectAvgTime,
                                        aname: r.Aname || "",
                                    }));
                                    // Format time in seconds to readable format (MM:SS or HH:MM:SS)
                                    const formatTime = (seconds) => {
                                        const secs = Math.round(seconds);
                                        const hours = Math.floor(secs / 3600);
                                        const mins = Math.floor((secs % 3600) / 60);
                                        const sec = secs % 60;
                                        if (hours > 0) {
                                            return `${hours}:${String(mins).padStart(2, '0')}:${String(sec).padStart(2, '0')}`;
                                        }
                                        return `${mins}:${String(sec).padStart(2, '0')}`;
                                    };
                                    return (
                                        <SimpleLineChart
                                            data={chartData}
                                            xKey="date"
                                            series={["correct", "incorrect"]}
                                            colors={["#2e7d32", "#d32f2f"]}
                                            seriesLabels={["Correct Avg Time", "Incorrect Avg Time"]}
                                            formatYValue={formatTime}
                                            tooltipKey="aname"
                                        />
                                    );
                                })()}
                            </CardContent>
                        </Card>
                        </Box>
                        {/* Question level counts over time using subject-category-level API */}
                        <Card
                            ref={levelTrendsRef}
                            elevation={3}
                            sx={{
                                borderRadius: 4,
                                margin: 0,
                                overflow: 'hidden',
                                border: '1px solid',
                                borderColor: tourOpen && tourSections[tourSection]?.targetRef === levelTrendsRef ? 'primary.main' : 'divider',
                                backgroundColor: 'background.paper',
                                outline: tourOpen && tourSections[tourSection]?.targetRef === levelTrendsRef ? '3px solid rgba(25,118,210,0.25)' : 'none',
                            }}
                        >
                            <CardHeader
                                sx={{
                                    pb: 1,
                                    textAlign: 'center',
                                }}
                                title={
                                    <Typography
                                        sx={{
                                            fontWeight: 600,
                                            fontSize: '1.125rem',
                                            color: 'text.primary',
                                            letterSpacing: '-0.01em',
                                            textAlign: 'center',
                                            width: '100%'
                                        }}
                                        variant="h6"
                                    >
                                        Level Trends (Counts)
                                    </Typography>
                                }
                            />
                            <CardContent>
                                <Typography variant="subtitle2" sx={{ mb: 1 }}>
                                    Easy / Intermediate / Advanced question counts
                                </Typography>
                                {(() => {
                                    const cat = selectedCategory || "__overall";
                                    const chartData = (subjectCategoryLevelStats || [])
                                        .filter(r => r.Category === cat)
                                        .sort((a, b) => (a.AttemptDate || "").localeCompare(b.AttemptDate || ""))
                                        .map(r => ({
                                            date: formatDateOnly(r.AttemptDate),
                                            easy: Number(r.EasyCount || 0),
                                            intermediate: Number(r.IntermediateCount || 0),
                                            advanced: Number(r.AdvancedCount || 0),
                                            aname: r.Aname || "",
                                        }));

                                    return (
                                        <SimpleLineChart
                                            data={chartData}
                                            xKey="date"
                                            series={["easy", "intermediate", "advanced"]}
                                            colors={["#0288d1", "#f57c00", '#4caf50']}
                                            seriesLabels={["Easy Count", "Intermediate Count", "Advanced Count"]}
                                            formatYValue={(v) => Math.round(v).toString()}
                                            tooltipKey="aname"
                                        />
                                    );
                                })()}
                            </CardContent>
                        </Card>
                                </Stack>
                            </CardContent>
                        </Card>
                        </Box>
                        <br></br>
                        <Card
                            elevation={6}
                            sx={{
                                display: "none",
                                borderRadius: 4,
                                margin: "5px",
                                overflow: 'hidden',
                                border: '1px solid',
                                borderColor: 'divider',
                                backgroundColor: 'background.paper',
                                boxShadow: (theme) => theme.palette.mode === 'dark'
                                    ? '0 4px 16px rgba(0,0,0,0.5), 0 0 0 1px rgba(255,255,255,0.1)'
                                    : '0 4px 16px rgba(0,0,0,0.1), 0 0 0 1px rgba(0,0,0,0.05)'
                            }}
                        >
                            <CardHeader
                                sx={{
                                    pb: 1,
                                    textAlign: 'center',
                                }}
                                title={
                                    <Typography
                                        sx={{
                                            fontWeight: 600,
                                            fontSize: '1.125rem',
                                            color: 'text.primary',
                                            letterSpacing: '-0.01em',
                                            textAlign: 'center',
                                            width: '100%'
                                        }}
                                        variant="h6"
                                    >
                                        Question Level Count Stats
                                    </Typography>
                                }
                            />
                            <CardContent sx={{ p: '0 12px 12px 12px', '&:last-child': { pb: '12px' } }}>
                                <Box sx={{
                                    borderRadius: '0 0 8px 8px',
                                    overflow: 'hidden'
                                }}>
                                    <Table>
                                        <TableHead>
                                            <TableRow>
                                                <StyledTableCell
                                                    sx={{
                                                        borderTopLeftRadius: '8px',
                                                        '&:first-of-type': {
                                                            borderTopLeftRadius: '8px'
                                                        }
                                                    }}
                                                >
                                                    Subject
                                                </StyledTableCell>
                                                <StyledTableCell>Category</StyledTableCell>
                                                <StyledTableCell>Easy</StyledTableCell>
                                                <StyledTableCell>Intermediate</StyledTableCell>
                                                <StyledTableCell
                                                    sx={{
                                                        borderTopRightRadius: '8px',
                                                        '&:last-of-type': {
                                                            borderTopRightRadius: '8px'
                                                        }
                                                    }}
                                                >
                                                    Advanced
                                                </StyledTableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {userQLevelStats && userQLevelStats.QLevelAttemptedStatList && userQLevelStats.QLevelAttemptedStatList.length > 0 ? (
                                                userQLevelStats.QLevelAttemptedStatList.map((row, idx) => {
                                                    const isLast = idx === userQLevelStats.QLevelAttemptedStatList.length - 1;
                                                    return (
                                                        <StyledTableRow key={idx}>
                                                            <StyledTableCell
                                                                sx={isLast ? {
                                                                    borderBottomLeftRadius: '8px',
                                                                    paddingBottom: '20px !important',
                                                                    paddingLeft: '16px !important',
                                                                    paddingTop: '16px'
                                                                } : {
                                                                    paddingLeft: '16px',
                                                                    paddingTop: '16px'
                                                                }}
                                                            >
                                                                {row.Qsubject}
                                                            </StyledTableCell>
                                                            <StyledTableCell
                                                                sx={isLast ? {
                                                                    paddingBottom: '20px !important',
                                                                    paddingTop: '16px'
                                                                } : { paddingTop: '16px' }}
                                                            >
                                                                {row.Qcategory}
                                                            </StyledTableCell>
                                                            <StyledTableCell
                                                                sx={isLast ? {
                                                                    paddingBottom: '20px !important',
                                                                    paddingTop: '16px'
                                                                } : { paddingTop: '16px' }}
                                                            >
                                                                {row.Easy}
                                                            </StyledTableCell>
                                                            <StyledTableCell
                                                                sx={isLast ? {
                                                                    paddingBottom: '20px !important',
                                                                    paddingTop: '16px'
                                                                } : { paddingTop: '16px' }}
                                                            >
                                                                {row.Intermediate}
                                                            </StyledTableCell>
                                                            <StyledTableCell
                                                                sx={isLast ? {
                                                                    borderBottomRightRadius: '8px',
                                                                    paddingBottom: '20px !important',
                                                                    paddingRight: '16px !important',
                                                                    paddingTop: '16px'
                                                                } : {
                                                                    paddingRight: '16px',
                                                                    paddingTop: '16px'
                                                                }}
                                                            >
                                                                {row.Advanced}
                                                            </StyledTableCell>
                                                        </StyledTableRow>
                                                    );
                                                })
                                            ) : (
                                                <StyledTableRow>
                                                    <StyledTableCell colSpan={7} sx={{ textAlign: 'center', py: 3 }}>
                                                        No Question Level Count data available
                                                    </StyledTableCell>
                                                </StyledTableRow>
                                            )}
                                        </TableBody>
                                    </Table>
                                </Box>
                            </CardContent>

                        </Card>
                        <br></br>
                        </AsyncSection>
                    </CardContent>
                </Card>
                {tourOpen && (
                    <Paper
                        elevation={12}
                        sx={{
                            position: "fixed",
                            right: 24,
                            bottom: 24,
                            width: { xs: "calc(100% - 32px)", sm: 390 },
                            p: 2,
                            borderRadius: 2,
                            zIndex: 2000,
                            border: "1px solid",
                            borderColor: "divider",
                        }}
                    >
                        <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
                            Section {tourSection + 1} of {tourSections.length}: {tourSections[tourSection].title}
                        </Typography>
                        <Typography variant="body2" sx={{ mt: 1, color: "text.secondary" }}>
                            {tourSections[tourSection].description}
                        </Typography>
                        <Box sx={{ display: "flex", justifyContent: "space-between", mt: 2 }}>
                            <Button onClick={closeTour} color="inherit">
                                Skip
                            </Button>
                            <Box sx={{ display: "flex", gap: 1 }}>
                                <Button
                                    variant="outlined"
                                    onClick={() => goToTourSection(tourSection - 1)}
                                    disabled={tourSection === 0}
                                >
                                    Back
                                </Button>
                                <Button
                                    variant="contained"
                                    onClick={() => goToTourSection(tourSection + 1)}
                                >
                                    {tourSection === tourSections.length - 1 ? "Done" : "Next"}
                                </Button>
                            </Box>
                        </Box>
                    </Paper>
                )}
            </Box>

        )
    }

    return (
        <Box sx={{ paddingBottom: '80px' }}>
            <PerUser />
        </Box>
    )
}

export default Overview;
